import { PocAssignee, PocAssigneeLabels } from "../../../../enums/pocAssignee";

export const allPocOptions = Object.values(PocAssignee).map((assignee) => ({
  label: PocAssigneeLabels[assignee],
  value: assignee,
}));
